<template>
  <div class="ribbon-container">
    <div v-if="color" class="ribbon-callout" :class="color">
      <span class="ribbon-content">{{ calloutText }}</span>
    </div>
    <div v-if="(color !== null && secondaryRibbons.length < 3 || color === null && secondaryRibbons.length < 4)">
      <div
        v-for="(ribbon, i) of secondaryRibbons"
        :key="'ribbon_'+i"
        :class="{'multiple-ribbon': i > 0, 'ribbon-callout': color === null, 'secondary-ribbon': color !== null || (color === null && i > 0) }"
        :style="{ zIndex: -(i+3) }"
        >
        <span
          :class="{'multiple-ribbon-content': i > 0, 'ribbon-content': color === null, 'secondary-ribbon-content': color !== null || (color === null && i > 0) }"
          >{{ ribbon.name }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Ribbon',
  props: {
    calloutText: {
      type: String,
      default: null
    },
    secondaryRibbons: {
      type: Array,
      default: () => ([])
    }
  },
  computed: {
    color () {
      if (!this.calloutText) {
        return null
      }
      if (this.calloutText.includes('Pre-Release') || this.calloutText.includes('Pre-Order')) {
        return 'orange'
      }
      switch (this.calloutText) {
        case 'New Release':
          return 'green'
        case 'Staff Pick':
          return 'red'
        case 'Best Seller':
          return 'blue-gray'
        default:
          return null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import './scss/variables';

  @mixin ribbon-color($color) {
    background: $color !important;
    &:after {
      border-top-color: $color;
      border-bottom-color: $color;
      border-left-color: $color;
    }
    .ribbon-content:before {
      border-color: adjust-color($color, $lightness: -15%) transparent transparent transparent;
    }
  }
  @mixin secondary-ribbon-color($color) {
    background: $color;
    &:after {
      border-top-color: $color;
      border-bottom-color: $color;
      border-left-color: $color;
    }
    .ribbon-content:before {
      border-right-color: $color;
      border-top-color: transparent;
      border-bottom-color: transparent;
      border-left-color: transparent;
    }
  }
  @mixin ribbon-height($height) {
    line-height: $height;
    top: -0.5 * $height;
    &:before {
      left: -0.5 * $height;
      border-width: $height / 2;
    }
    &:after {
      right: -0.5 * $height;
      border-width: $height / 2;
    }
  }

  @mixin ribbon-width($width) {
  width: $width;
  &:before {
    left: -0.5 * $width;
    border-width: $width / 2;
  }
  &:after {
    right: -0.5 * $width;
    border-width: $width / 2;
  }
}

  .ribbon-container {
    position: absolute;
    left: -1.4em;
    top:0;
    z-index: 15;
    width:100%;
    border-radius:0 !important;
    .hide-ribbon {
      display:none;
    }
    .multiple-ribbon {
      background:transparent !important;
      color:$dark-blue !important;
      display:block;
      padding-left:.5em;
      clear:left;
      :before {
        content:"• ";
      }
      &:before {
        display:none !important;
      }
      &:after {
        display:none !important;
      }
      .multiple-ribbon-content {
        padding-left:.5em !important;
      }
    }
    .ribbon-callout {
      @include ribbon-color($dark-blue);
      @include ribbon-height(24px);

      float:left;
      font-size: 14px;
      font-weight: bold;
      position:relative;
      top:-12px;
/*       position: absolute;
      left: -1em;
 */
      color: $white;
      text-align: center;
      /* z-index: 15; */
      border-radius: 0 !important;

      &:after {
        content: "";
        position: absolute;
        display: block;
        top: 0;
        bottom: 0;
        z-index: -1;
        border-style: solid;
        border-right-color: transparent;
      }
      .ribbon-content {
        color: $white;
        width: 100%;
        padding: 0 1em;

        &:before {
          content: "";
          position: absolute;
          display: block;
          border-style: solid;
          bottom: -1em;
        }
        &:before {
          left: 0;
          border-width: 1em 0 0 1em;
        }
      }

      &.orange {
        @include ribbon-color($orange)
      }
      &.green {
        @include ribbon-color($dark-green)
      }
      &.red {
        @include ribbon-color($red)
      }
      &.blue-gray {
        @include ribbon-color($blue-gray)
      }
    }
    .secondary-ribbon {
      @include secondary-ribbon-color($dark-blue);
      @include ribbon-height(24px);

      font-size: 14px;
      font-weight: bold;
      position: relative;
      float:left;
      margin-left:0px;
      top:-12px;
      color: $white;
      text-align: center;
      z-index: -2;
      padding: 0 1em;
      border-radius: 0 !important;
      &:before {
        content: "";
        position: absolute;
        display: block;
        top: 0;
        bottom: 0;
        left:0;
        z-index: -1;
        border-style: solid;
        border-right-color: transparent;
      }

    &:after {
        content: "";
        position: absolute;
        display: block;
        top: 0;
        bottom: 0;
        z-index: -2;
        border-style: solid;
        border-right-color: transparent;
      }
      .secondary-ribbon-content {
        width: 100%;
        padding: 0em 0em 0em 1.5em;
      }

      &.orange {
        @include secondary-ribbon-color($orange)
      }
      &.green {
        @include secondary-ribbon-color($dark-green)
      }
      &.red {
        @include secondary-ribbon-color($red)
      }
      &.blue-gray {
        @include secondary-ribbon-color($blue-gray)
      }
    }
  }
  @media screen and (max-width: $breakpoint-sm) {
    .ribbon-callout {
      @include ribbon-height(16px);
      @include ribbon-width(150px);
      width:auto;
      font-size: 10px;
      font-weight: $font-weight-extra;
    }
    .secondary-ribbon {
      @include ribbon-height(16px);
      @include ribbon-width(150px);
      font-size: 10px;
      font-weight: $font-weight-extra;
    }
  }
</style>
